export const LayoutContent: string[] = [
    'DASHBOARD',
    'ALL_TRANSACTIONS',
    // 'CRYPTO_TRANSACTIONS',
    'BANK_TRANSACTIONS',
    'CUSTODY_TRANSACTIONS',
    'CARDS',
    'PRIVATE_CLIENTS',
    'BUSINESS_CLIENTS',
    'INACTIVE_CLIENTS',
    'KYC_AML',
    'KYC_MEETINGS',
    'SUPPORT_MANAGER',
    'EXCHANGE_SERVICE',
    // 'CRYPTO_SERVICE',
    'SYSTEM_USERS',
    'SETTINGS',
    'COUNTRY_LIMIT',
    'PRODUCT_MANAGEMENT',
    'SERVICE_MANAGEMENT',
    'TIER_CONTROL',
    'STATISTICS',
    'DASH_PENDING_TOTAL_COUNT',
    // 'CRYPTO_STATISTICS_TAB',
    'USER_SOURCE',
    'FREEZE_ACCOUNT',
    'MULTIPLE_KYC_TIER_THREE',
    'INDIVIDUAL_COMMISSION',
    'ACTION_CENTER',
    'TRANSACTION_APPROVALS',
    'NOTIFICATION_TRIGGERS',
    'REFERRAL_PROGRAM'
];

export const PageFilter: { [key: string]: { [key: string]: string[] } } = {
    'SHARED': {
        'LIMIT_CONTROL_TABLE': ['CUSTOMER_BANK']
    },
    'COMMISSIONS': {
        'ACCOUNT_AND_BALANCE': ['INCOMING_WIRE_TRANSFER', 'OUTGOING_WIRE_TRANSFER', 'MAINTAINING_BALANCE_COST', 'MAINTAINING_ACCOUNT_COST'/*, 'INCOMING_WIRE_TRANSFER_EUR_TRUST', 'OUTGOING_WIRE_TRANSFER_EUR_TRUST'*/],
        'PRODUCT_TRANSACTION_REPORTING': [/*'EXCHANGE',*/ /*'CRYPTO',*/ 'KYC', 'EBANKING', /*'TRUST',*/ 'CARD', 'ACCOUNT', '3RD_PRODUCTS', 'TOTAL'],
        'COST_OF_PRODUCTS': ['ClearJunction', /*'Trust',*/ 'Card', 'Account', 'SumSub', /*'Crypto'*/]
    },
    'COUNTRY_LIMIT': {
        'TABLE': ['iban', /*'trust',*/ 'physicalCard', 'virtualCard']
    },
    'USERS': {
        'USER_TURNOVERS': ['CUSTOMER_BANK', 'CUSTODY'],
        'USER_ACCOUNTS': ['CUSTOMER_BANK', 'CUSTODY']
    },
    'SETTINGS': {
        'TX_LIMITS': ['eur']
    }
};

export const TableFilters: { [key: string]: { label: string, value: string }[] } = {
    'CURRENCY_FILTER': [
        // { label: 'BTC', value: 'BTC' },
        // { label: 'LTC', value: 'LTC' },
        // { label: 'DASH', value: 'DASH' },
        // { label: 'ETH', value: 'ETH' },
        // { label: 'EUR TRUST', value: 'EUR_TRUST' },
        // { label: 'EUR', value: 'EUR' }
    ],
    'ALL_TRANSACTIONS_TYPE': [
        // { label: 'Crypto', value: 'CRYPTO' },
        // { label: 'Exchange', value: 'EXCHANGE' },
        { label: 'Bank', value: 'BANK' },
        { label: 'Iban', value: 'CUSTOMER_BANK' },
        { label: 'Service', value: 'SERVICE' },
        // { label: 'Custody', value: 'CUSTODY' }
    ],
    'ALL_TRANSACTION_SUBTYPE': [
        { label: 'Deposit', value: 'DEPOSIT' },
        { label: 'Withdrawal', value: 'WITHDRAW' },
        { label: 'Commission', value: 'COMMISSION' },
        { label: 'Payment', value: 'PAYMENT' },
        { label: 'Transfer', value: 'TRANSFER' }
    ],
    'CRYPTO_TRANSACTIONS_TYPE': [
        // { label: 'Crypto', value: 'CRYPTO' },
        // { label: 'Exchange', value: 'EXCHANGE' },
        // { label: 'Service', value: 'SERVICE' }
    ],
    'CRYPTO_TRANSACTION_SUBTYPE': [
        // { label: 'Deposit', value: 'DEPOSIT' },
        // { label: 'Withdrawal', value: 'WITHDRAW' },
        // { label: 'Commission', value: 'COMMISSION' },
        // { label: 'Payment', value: 'PAYMENT' }
    ],
    'SOURCE': [
        { label: 'Trustee', value: 'TRUSTEE' },
        { label: 'WeWe', value: 'WEWE' }
    ],
    'INDIVIDUAL_COMMISSION': [
        { label: 'Active', value: '1' },
        { label: 'Unactive', value: '0' }
    ],
    'KYC_TIERS': [
        { label: 'Not Verified', value: '0' },
        { label: 'Silver', value: '1' },
        { label: 'Gold', value: '2' },
        { label: 'Platinum', value: '3' },
        { label: 'Platinum 2', value: '4' },
        { label: 'Platinum 3', value: '5' },
        { label: 'Platinum 4', value: '6' },
        { label: 'Platinum 5', value: '7' },
    ],
    'RISK_SCORE': [],
    'TRANSACTIONS_MONITORING': [
        { label: 'Monitored all transactions', value: '1' }
    ],
};

export const systemCurrency: string = 'EUR';
